import React from "react";
import type { GolfParkSearchResponse } from "../../../@apis/dto/response/main.response";
import SearchLayout from "../../layout/search";
import CloseAppBar from "../appbar/CloseAppbar";
import BaseModal from "./base/BaseModal";

interface ModalProps extends ModalComponentProps {
  onClick: (item: GolfParkSearchResponse) => void;
}

export default function SelectGolfParkStoreModal({ close, onClick }: ModalProps) {
    // 모달 내부 스크롤 컨테이너를 무한 스크롤 감지 root로 넘겨준다.
    const [scrollRoot, setScrollRoot] = React.useState<HTMLDivElement | null>(null);

    return (
        <BaseModal size={"full"} close={close}>
            <CloseAppBar title="골프장 검색" onBack={close}/>
            <div ref={setScrollRoot} className="flex-1 overflow-y-auto">
                <SearchLayout scrollRoot={scrollRoot} onClick={(item) => {
                    onClick(item);
                    close();
                }}/>
            </div>
        </BaseModal>
    );
}